import {ActivatedRouteSnapshot, RedirectCommand, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AppService} from "../app.service";


export const ArticleResolver = async (
  route: ActivatedRouteSnapshot
): Promise<any | RedirectCommand> => {
  const router = inject(Router);
  const appService = inject(AppService);


  const slugTheme = route.paramMap.get('slugTheme');
  const slugArticle = route.paramMap.get('slugArticle');

  if (!slugTheme || !slugArticle) {
    return new RedirectCommand(router.parseUrl('/404'),{skipLocationChange: false});
  }

  try {
    const article = await appService.getArticle(slugTheme, slugArticle);
    if (article) {
      return article;
    } else {

      return new RedirectCommand(router.parseUrl('/404'),{skipLocationChange: false});
    }
  } catch {
    return new RedirectCommand(router.parseUrl('/404'),{skipLocationChange: false});
  }
};
